var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _g2, _path26, _g3, _path27, _g4, _path28, _g5, _path29, _g6, _path30, _g7, _path31, _g8, _path32, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 43,
    viewBox: "0 0 153 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8087 26.4249H76.2709C77.7474 26.4249 78.5112 27.3414 78.5112 28.4106C78.5112 28.9198 78.3075 29.6835 77.4419 30.0399C77.9511 30.2436 78.8676 30.6 78.8676 31.9747C78.8676 33.2476 77.9002 34.3168 76.1691 34.3168H72.7578V26.4249H72.8087ZM73.8779 29.7853H75.8127C76.831 29.7853 77.4419 29.4798 77.4419 28.5124C77.4419 27.7996 76.9837 27.3414 75.8127 27.3414H73.8779V29.7853ZM73.8779 33.4512H76.1691C77.2892 33.4512 77.8493 32.8911 77.8493 32.0256C77.8493 30.9055 76.8819 30.7018 76.0163 30.7018H73.9288V33.4512H73.8779Z",
    fill: "#024DA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8063 34.3677V33.553C83.399 34.2149 82.8899 34.5713 81.9734 34.5713C81.1078 34.5713 80.0895 34.164 80.0895 32.7893V28.6652H81.0569V32.4838C81.0569 33.4512 81.5661 33.7567 82.1771 33.7567C83.399 33.7567 83.7554 32.6875 83.7554 31.8219V28.6652H84.7228V34.4186H83.8063V34.3677Z",
    fill: "#024DA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.458 30.2436C89.458 29.8872 89.3052 29.2762 88.0833 29.2762C87.7778 29.2762 86.9631 29.378 86.9631 30.0908C86.9631 30.5491 87.2686 30.7018 87.9814 30.8546L88.9488 31.1091C90.1199 31.4146 90.5781 31.822 90.5781 32.6366C90.5781 33.8077 89.6107 34.5205 88.2869 34.5205C85.9957 34.5205 85.843 33.1967 85.7921 32.4839H86.7086C86.7595 32.9421 86.8613 33.6549 88.236 33.6549C88.9488 33.6549 89.5598 33.4003 89.5598 32.7384C89.5598 32.2802 89.2543 32.1275 88.4397 31.9238L87.3195 31.6692C86.5049 31.4656 85.9957 31.0582 85.9957 30.2436C85.9957 28.9707 87.065 28.4106 88.1851 28.4106C90.2217 28.4106 90.3744 29.9381 90.3744 30.2436H89.458Z",
    fill: "#024DA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.749 27.5451V26.4249H92.7164V27.5451H91.749ZM92.7164 34.3677H91.749V28.5634H92.7164V34.3677Z",
    fill: "#024DA3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8772 34.3677H97.9098V30.8037C97.9098 29.7854 97.6043 29.2762 96.6878 29.2762C96.1277 29.2762 95.1604 29.6326 95.1604 31.211V34.3677H94.1421V28.5634H95.0585V29.378C95.2622 29.0725 95.8223 28.4106 96.7896 28.4106C97.6552 28.4106 98.8263 28.7671 98.8263 30.3963L98.8772 34.3677Z",
    fill: "#024DA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.191 32.5348C105.14 32.7893 104.885 33.604 104.172 34.1131C103.918 34.3168 103.511 34.5205 102.594 34.5205C100.965 34.5205 99.9974 33.2985 99.9974 31.6183C99.9974 29.8363 100.863 28.4106 102.747 28.4106C104.427 28.4106 105.242 29.7344 105.242 31.771H101.016C101.016 32.993 101.576 33.6549 102.696 33.6549C103.612 33.6549 104.172 32.9421 104.172 32.5348H105.191ZM104.274 31.0073C104.223 30.0908 103.867 29.2762 102.645 29.2762C101.729 29.2762 101.067 30.0908 101.067 31.0073H104.274Z",
    fill: "#024DA3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.722 30.2436C109.722 29.8872 109.569 29.2762 108.347 29.2762C108.042 29.2762 107.176 29.378 107.176 30.0908C107.176 30.5491 107.482 30.7018 108.195 30.8546L109.162 31.1091C110.384 31.4146 110.791 31.822 110.791 32.6366C110.791 33.8077 109.824 34.5205 108.5 34.5205C106.209 34.5205 106.056 33.1967 106.005 32.4839H106.973C107.024 32.9421 107.125 33.6549 108.5 33.6549C109.213 33.6549 109.824 33.4003 109.824 32.7384C109.824 32.2802 109.518 32.1275 108.653 31.9238L107.533 31.6692C106.718 31.4656 106.209 31.0582 106.209 30.2436C106.209 28.9707 107.227 28.4106 108.398 28.4106C110.486 28.4106 110.588 29.9381 110.588 30.2436H109.722Z",
    fill: "#024DA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.221 30.2436C115.221 29.8872 115.068 29.2762 113.846 29.2762C113.541 29.2762 112.675 29.378 112.675 30.0908C112.675 30.5491 112.981 30.7018 113.694 30.8546L114.661 31.1091C115.883 31.4146 116.29 31.822 116.29 32.6366C116.29 33.8077 115.323 34.5205 113.999 34.5205C111.708 34.5205 111.555 33.1967 111.504 32.4839H112.421C112.472 32.9421 112.573 33.6549 113.948 33.6549C114.661 33.6549 115.272 33.4003 115.272 32.7384C115.272 32.2802 114.966 32.1275 114.152 31.9238L113.032 31.6692C112.217 31.4656 111.708 31.0582 111.708 30.2436C111.708 28.9707 112.726 28.4106 113.897 28.4106C115.985 28.4106 116.087 29.9381 116.087 30.2436H115.221Z",
    fill: "#024DA3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.219 28.818C125.913 27.4433 124.742 27.1887 123.978 27.1887C122.553 27.1887 121.382 28.2579 121.382 30.3454C121.382 32.2293 122.044 33.6549 124.029 33.6549C124.742 33.6549 125.913 33.3494 126.321 31.4656H127.339C126.881 34.4696 124.488 34.5714 123.877 34.5714C122.095 34.5714 120.313 33.4003 120.313 30.3454C120.313 27.9015 121.687 26.2213 124.029 26.2213C126.066 26.2213 127.135 27.4942 127.288 28.818H126.219Z",
    fill: "#024DA3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.398 32.5348C133.347 32.7893 133.092 33.604 132.379 34.1131C132.125 34.3168 131.717 34.5205 130.801 34.5205C129.172 34.5205 128.204 33.2985 128.204 31.6183C128.204 29.8363 129.07 28.4106 130.954 28.4106C132.634 28.4106 133.449 29.7344 133.449 31.771H129.274C129.274 32.993 129.834 33.6549 130.954 33.6549C131.87 33.6549 132.379 32.9421 132.43 32.5348H133.398ZM132.481 31.0073C132.43 30.0908 132.074 29.2762 130.852 29.2762C129.935 29.2762 129.274 30.0908 129.274 31.0073H132.481Z",
    fill: "#024DA3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139.355 34.3677H138.387V30.8037C138.387 29.7854 138.082 29.2762 137.165 29.2762C136.605 29.2762 135.638 29.6326 135.638 31.211V34.3677H134.671V28.5634H135.587V29.378C135.791 29.0725 136.351 28.4106 137.318 28.4106C138.235 28.4106 139.355 28.7671 139.355 30.3963V34.3677Z",
    fill: "#024DA3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.951 29.3781V33.1458C141.951 33.6041 142.359 33.6041 142.562 33.6041H142.919V34.3678C142.562 34.4187 142.308 34.4696 142.206 34.4696C141.239 34.4696 141.035 33.9096 141.035 33.2477V29.429H140.271V28.6144H141.035V26.9851H142.002V28.6144H142.919V29.429L141.951 29.3781Z",
    fill: "#024DA3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.723 32.5348C148.672 32.7893 148.418 33.604 147.705 34.1131C147.45 34.3168 147.094 34.5205 146.126 34.5205C144.497 34.5205 143.53 33.2985 143.53 31.6183C143.53 29.8363 144.395 28.4106 146.279 28.4106C147.959 28.4106 148.774 29.7344 148.774 31.771H144.548C144.548 32.993 145.108 33.6549 146.228 33.6549C147.145 33.6549 147.654 32.9421 147.705 32.5348H148.723ZM147.807 31.0073C147.756 30.0908 147.348 29.2762 146.177 29.2762C145.261 29.2762 144.599 30.0908 144.599 31.0073H147.807Z",
    fill: "#024DA3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.065 34.3677H150.098V28.5634H151.014V29.5308C151.422 28.8689 151.931 28.4106 152.644 28.4106C152.745 28.4106 152.847 28.4106 152.898 28.4616V29.4799H152.542C151.625 29.4799 151.065 30.1927 151.065 31.0073V34.3677Z",
    fill: "#024DA3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6159 34.3677V26.2213H45.2635V28.9707H47.7583V26.2213H50.4059V34.3168H47.7583V31.211H45.2635V34.3677H42.6159Z",
    fill: "#024DA3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0353 26.2213H54.6829V31.0583C54.6829 31.8729 54.8356 32.5348 55.9558 32.5348C56.9231 32.5348 57.1777 31.9238 57.1777 31.0583V26.2213H59.8253V30.8037C59.8253 33.4003 58.6033 34.5714 55.9048 34.5714C53.41 34.5714 51.9844 33.604 51.9844 30.8037V26.2213H52.0353Z",
    fill: "#024DA3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4546 34.3677V26.2213H65.3242C67.1571 26.2213 68.6337 26.6286 68.6337 28.2579C68.6337 29.0726 68.0736 29.6835 67.5644 30.0399C68.43 30.2436 68.9391 31.0073 68.9391 31.8729C68.9391 33.7058 67.5644 34.3168 65.426 34.3168L61.4546 34.3677ZM64.1022 28.1052V29.4799H65.2223C65.7315 29.4799 66.1388 29.2253 66.1388 28.7671C66.1388 28.1561 65.6297 28.1561 65.0696 28.1561H64.1022V28.1052ZM64.1022 30.9564V32.433H65.2733C65.9352 32.433 66.4443 32.2802 66.4443 31.6692C66.4443 30.9564 65.8333 30.9055 64.9678 30.9055H64.1022V30.9564Z",
    fill: "#024DA3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.538 14.8672C145.312 14.969 146.025 19.5514 146.025 19.5514H143.988C144.243 18.0239 144.141 15.8855 144.141 15.8855H142.817C142.817 17.7184 142.766 18.7877 142.664 19.5514C141.748 23.0645 138.846 21.9444 138.846 21.9444C138.846 21.9444 138.795 22.0462 138.489 23.1664C142.155 24.2865 143.632 20.8752 143.632 20.8752C143.632 20.8752 144.752 20.8752 148.876 20.8752C153 20.8752 153 18.1767 153 17.8712C153 14.969 149.996 14.9181 149.538 14.8672ZM149.283 19.5514H147.247C147.247 19.5514 146.788 16.0891 149.436 16.0891C149.64 16.0891 151.625 16.191 151.625 17.973C151.676 18.2276 151.676 19.5514 149.283 19.5514Z",
    fill: "#024DA3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.659 14.5616C126.052 14.5616 126.371 14.2425 126.371 13.8488C126.371 13.4551 126.052 13.136 125.659 13.136C125.265 13.136 124.946 13.4551 124.946 13.8488C124.946 14.2425 125.265 14.5616 125.659 14.5616Z",
    fill: "#024DA3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.709 15.8855H127.033C127.033 15.8855 127.084 18.2785 126.881 19.5514H136.962C136.962 19.5514 137.013 17.1584 134.11 17.1584C131.157 17.1584 129.935 17.1584 129.935 17.1584C129.935 17.1584 129.477 17.1583 129.121 16.8019C128.764 16.4455 128.866 15.6309 129.528 14.9181C130.139 14.2053 131.565 12.3214 136.758 12.3214V13.6452C136.758 13.6452 132.023 13.3397 130.648 15.9364C133.398 15.9364 133.092 15.8855 133.856 15.8855C134.62 15.8855 136.911 15.6818 138.031 17.9221C138.235 18.3803 138.591 19.2459 138.387 20.8752H126.422C126.422 20.8752 125.048 24.2356 121.331 23.1663L121.687 21.9444C121.687 21.9444 124.437 22.9118 125.506 19.6532C125.659 18.6349 125.709 18.6349 125.709 15.8855Z",
    fill: "#024DA3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4986 21.2825C93.2766 21.2825 92.8693 21.2316 92.7675 21.1807C91.1382 20.8752 90.2726 19.8569 90.2726 18.3294C90.2726 17.9221 90.3744 17.5148 90.5272 17.1075L90.6799 16.8529L92.7675 17.2602L92.5129 17.7185C92.4111 17.8712 92.4111 17.973 92.4111 18.1258C92.4111 18.6349 92.5638 18.9913 93.4294 19.0422H93.4803C93.6839 19.0932 93.8876 19.0932 93.8876 19.0932H100.557V15.0709H102.594V19.0932H103.867C104.071 17.1584 106.158 15.58 108.857 15.2236V14.2562H110.995V15.2236C112.981 15.4782 114.661 16.3947 115.425 17.7185L115.628 18.1258C115.628 18.1767 115.679 18.2785 115.679 18.2785C116.239 19.5005 115.934 20.8752 115.934 20.977L115.883 21.2825H95.2623C95.0077 21.2825 94.7531 21.2825 94.4986 21.2825ZM113.795 19.1441C113.439 18.2785 112.37 17.6166 110.995 17.362V19.1441H113.795ZM108.857 19.1441V17.362C107.482 17.6166 106.413 18.2785 106.056 19.1441H108.857Z",
    fill: "#024DA3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6552 23.1153C97.6552 23.6754 97.1969 24.1846 96.5859 24.1846C95.975 24.1846 95.5167 23.7263 95.5167 23.1153C95.5167 22.5044 95.975 22.097 96.5859 22.097C97.1969 22.097 97.6552 22.5553 97.6552 23.1153Z",
    fill: "#024DA3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7361 18.6858C43.7361 18.6858 43.7361 21.2316 46.2819 21.2316C46.8419 21.2316 48.8276 20.8242 48.8276 18.6858V12.3214H50.1514V18.7876C50.1514 18.7876 50.1005 22.5554 46.3328 22.5554C42.5651 22.5554 42.5142 18.7367 42.5142 18.7367L43.7361 18.6858Z",
    fill: "#024DA3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8412 19.5514H67.5135C64.6113 19.3986 65.1205 17.7693 65.1714 17.5148C65.986 15.6818 67.819 16.191 68.0226 16.2928C69.4992 16.8019 69.4482 18.0748 69.4482 18.0748H70.772C70.7211 16.2419 69.2955 15.4782 68.9391 15.2745C66.4442 14.2053 65.0186 15.58 64.6113 15.9364C63.1857 17.6166 64.0003 19.144 64.3058 19.5514H62.0655C62.1165 19.3477 62.1674 19.0931 62.1674 18.8385C62.1674 17.0565 60.589 15.58 58.6542 15.58C56.7195 15.58 55.1411 17.0565 55.1411 18.8385C55.1411 19.0931 55.192 19.3477 55.2429 19.5514H52.8499V12.3214H51.5261V20.0096C51.5261 20.0096 51.4752 20.8752 52.2898 20.8752H55.9048C56.5667 21.6389 57.5341 22.0971 58.6542 22.0971C59.7744 22.0971 60.7417 21.588 61.4036 20.8752H71.8922L71.8412 19.5514ZM58.6033 20.8242C57.3813 20.8242 56.363 19.9587 56.363 18.8895C56.363 17.8202 57.3813 16.9547 58.6033 16.9547C59.8253 16.9547 60.8436 17.8202 60.8436 18.8895C60.8436 19.9587 59.8762 20.8242 58.6033 20.8242Z",
    fill: "#024DA3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7068 14.0016L73.0123 12.7796C73.0123 12.7796 77.8492 13.5943 78.3584 18.9913C78.8166 18.3803 79.0712 18.3294 79.0712 16.4455V12.3723H80.395V17.1584C80.395 17.1584 80.4459 18.7367 79.5804 19.6023H82.8898V12.3214H84.2136V20.0096C84.2136 20.0096 84.2136 20.8242 83.4499 20.8242H73.1141V19.5004H77.0855C77.0855 19.6023 76.9328 15.0199 72.7068 14.0016Z",
    fill: "#024DA3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.464 16.0892L34.5205 24.6429L36.5571 24.1847L17.5658 13.6453L6.00806 24.1338L7.12819 24.5411L17.3621 16.0383L17.464 16.0892Z",
    fill: "#004E96"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.04 35.2842L17.413 33.8077H17.3621L12.1179 35.3352L6.2117 34.6733L17.3621 31.3129L35.8952 34.6733L30.04 35.2842Z",
    fill: "#004E96"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.413 13.4416L6.1098 23.7774V20.0097L17.413 7.28088V13.4416Z",
    fill: "#B5D2EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95712 25.8649L17.2603 16.4456V22.6572L5.95712 29.4289V25.8649Z",
    fill: "#B5D2EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95712 30.7018L17.2603 24.9993V31.1091L5.95712 34.5204V30.7018Z",
    fill: "#B5D2EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.557 23.7774L17.6675 13.3907V7.22998L36.557 20.0097V23.7774Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3534 29.4289L17.5148 22.6063V16.3947L36.3534 25.8649V29.4289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3534 34.5204L17.5148 31.1091V24.9993L36.3534 30.7018V34.5204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_34_64",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 43
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5141 0H0V42.5141H42.5141V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_34_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4639 24.6939L34.7242 29.8873L36.2516 29.6836L17.3621 22.861L5.95712 29.6836L6.92451 29.8873L17.3621 24.6939H17.4639Z",
    fill: "#004E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b359104f4b3013ccf416b47db6a0ca13.svg";
export { ForwardRef as ReactComponent };